// src/components/CalendarSelector.js
import React from 'react';
import { DayPicker } from 'react-day-picker';
import { ptBR } from 'date-fns/locale';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Importamos o estilo base PRIMEIRO
import 'react-day-picker/dist/style.css'; 
// Importamos o NOSSO estilo customizado DEPOIS para sobrescrever
import '../assets/css/CalendarSelector.css'; 

function CalendarSelector({ selectedDate, onDateSelect, disabledDays, reservationType }) {
    // Definimos os limites de navegação do calendário
    const today = new Date();
    
    // Calcula exatamente 6 meses para frente
    const maxDate = new Date();
    if (reservationType === 'deliparty'){
        maxDate.setMonth(today.getMonth() + 5);
    }else{
        maxDate.setMonth(today.getMonth() + 2);
    }

    return (
        <div className="calendar-wrapper">
            <DayPicker
                mode="single"
                selected={selectedDate}
                onSelect={onDateSelect}
                disabled={disabledDays}
                locale={ptBR}
                showOutsideDays
                // Nativas do DayPicker para travar a navegação de meses:
                startMonth={today}
                endMonth={maxDate}
                components={{
                    // Mantemos seus ícones Lucide na cor Esmeralda
                    IconLeft: () => <ChevronLeft size={18} color="#528a89" />,
                    IconRight: () => <ChevronRight size={18} color="#528a89" />,
                }}
            />
        </div>
    );
}

export default CalendarSelector;